import PropTypes from 'prop-types';

import { StyledLink, StyleSideBarBrand } from './Logo.styles';
import brandImage from '../../../assets/brand/kandasearch-brand-logo.svg';
import brandName from '../../../assets/brand/kandasearch-brand-name.svg';
import { PRIVATE_ROUTE } from '../../../routes/routes';
import Svg from '../../elements/svg/Svg';

const Logo = ({ open, ...restProps }) => {
  const redirectTo = PRIVATE_ROUTE.PROJECTS;

  return (
    <StyledLink open={open} to={redirectTo} {...restProps}>
      <StyleSideBarBrand open={open}>
        <Svg brandImage src={brandImage} />
        <Svg brandName src={brandName} />
      </StyleSideBarBrand>
    </StyledLink>
  );
};

Logo.propTypes = {
  open: PropTypes.bool,
};

export default Logo;
